<template>
  <section class="intro">
    <Logo icon class="intro__logo" />
    <h2 class="intro__title">Hipotecarse es un viaje y queremos hacerlo contigo.</h2>
    <p class="intro__body">
      Por eso, te acompañamos desde que empiezas a buscar tu hipoteca, hasta el día de la firma, pasando por la entrega de documentos y la
      negociación para encontrar las mejores condiciones.
    </p>
    <p class="intro__highlighted">
      Y lo mejor de todo, es que no te costará nada
      <span class="intro__remarked">
        porque nuestro servicio es gratuito.
        <img class="intro__underline" src="img/web/underline.svg" alt="Icono subrayado" />
      </span>
    </p>
  </section>
</template>

<script>
import Logo from '@/lego/components/layout/Logo.vue';

export default {
  components: { Logo },
};
</script>

<style scoped lang="postcss">
.intro {
  @apply container text-center py-sm sm:py-xxl sm:container-col-6 xl:container-col-8 flex flex-col items-center max-w-[50rem] mx-auto;

  &__logo {
    @apply w-lg;
  }

  &__title {
    @apply style-subtitle-bold lg:style-title-sm-bold mt-xxxs lg:mt-xs;
  }

  &__body {
    @apply mt-xxxs style-body;
  }

  &__highlighted {
    @apply mt-sm style-body-bold;
  }

  &__remarked {
    @apply block text-brand-primary-dark;
  }

  &__underline {
    @apply block mx-auto mb-xxs lg:mb-0;
  }
}
</style>
